<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WG3giz/tc-custom/9781504095785.jpg?1731883397343" alt="This image is the cover for the book Lost Girl, The Mickey Keller Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Girl, The Mickey Keller Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An ex-detective turned professional fixer finds himself up against a desperate widow out for the truth in this thriller series debut.</b></p><p> Attorney Amy Robbins had the perfect life until a fatal accident robbed her of her young daughter and husband. Mired in a depressive fog, she soon tanks her career and drains her life savings. Now she passes her days working a dead-end job—until an unsettling discovery upends everything she thought she knew about her family . . . and her future.  </p><p> As Amy goes to desperate lengths to uncover the truth, she enlists the help of her sister-in-law, FBI Agent Loren Ryder. But someone is paying professional fixer Mickey Keller to make sure they don’t succeed. As Mickey squares off against Amy and Loren, the former cop and military man realizes he’s never faced such determined opponents. Soon all three find themselves hurtling toward a heart-pounding climax that will leave readers wondering who are the good guys and who are the bad. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Jacobson
      </h2>
      
      <p class="authorDescription body article">Alan Jacobson is the national bestselling author of the critically acclaimed FBI profiler Karen Vail and OPSIG Team Black series. Jacobson&rsquo;s years of extensive research and training while embedded with federal and local law enforcement agencies have influenced him both personally and professionally, and have helped shape the stories he tells and the diverse characters that populate his novels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?784e56d0